import React from 'react'
import type { DefaultValues, FieldValues, UseFormReset } from 'react-hook-form'

interface ResetFormValuesProps<T extends FieldValues> {
  reset: UseFormReset<T>
  formValues: DefaultValues<T>
  shouldResetValues: boolean
}

export const useResetFormValues = <T extends FieldValues>({
  reset,
  formValues,
  shouldResetValues,
}: ResetFormValuesProps<T>): void => {
  React.useEffect(() => {
    if (shouldResetValues) {
      reset(formValues)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldResetValues])
}
